import { handleSettledPromises } from '@kk/shared/utils/async';
import { assertParamsPrescence } from '@kk/shared/utils/validators';
import { useRouteLoaderData } from 'react-router';
import { assertNoLoaderErrors } from '#/api/errors';
import { fetchCompanyInfoQuery } from '#/api/hooks/useCompanyInfo';
import { fetchConfigQuery } from '#/api/hooks/useConfig';
import { fetchEarliestValidFilterDateQuery } from '#/api/hooks/useEarliestValidFilterDate';
import { fetchLoanPortfolioQuery } from '#/api/hooks/useLoanPortfolio';

export type LoaderData = Awaited<ReturnType<typeof loader>>;

export type Params = Record<string, string | undefined>;

export const id = 'contract-overview-page' as const;

async function loader({
  params,
  request,
}: {
  params: Params;
  request?: Request;
}) {
  assertParamsPrescence(params);
  if (!request) {
    throw new Error('Request is required');
  }
  const date = new URL(request.url).searchParams.get('dato');
  const data = await handleSettledPromises([
    fetchLoanPortfolioQuery({ filterDate: date }),
    fetchEarliestValidFilterDateQuery(),
    fetchCompanyInfoQuery(),
    fetchConfigQuery(),
  ]);

  assertNoLoaderErrors(id, data);

  const [loanPortfolio, earliestValidFilterDate, companyInfo, config] = data;

  return {
    loanPortfolio,
    earliestValidFilterDate,
    companyInfo,
    config,
  };
}

export const useContractOverviewPageLoaderData = () =>
  useRouteLoaderData(id) as LoaderData;

export default loader;
